<script>
  import DeleteModal from "../DeleteModal.svelte";
  import EditModal from "../EditModal.svelte";
  export let timesheetId;
  export let job;
  export let user;
  export let deliverable;
  export let task;
  export let totalhours;
  export let title;
  export let day;
  export let weekstart;
  export let staff;
  export let jobid;
  export let id;
  export let taskid;
  export let completed;
  export let activityid;
  export let actualstart;
  export let status;
  export let newdate;
  export let collapseAll;
  let openEdit = false;
  let toggleEdit = () => (openEdit = !openEdit);
  let open = false;
  let toggle = () => (open = !open);
  export let showDetails;
  let data = {
    weekStart: weekstart,
    staff: staff,
    timesheetId: timesheetId,
    job: jobid,
    jobname: job,
    del: id,
    delname: deliverable,
    task: taskid,
    taskname: task,
    note: title,
    date: day,
    totalhours: totalhours,
    day: day,
    completed: completed,
    activityid: activityid,
    actualstart: actualstart
  };
  let openedCards = [];
  let cards = [];
  cards = JSON.parse(localStorage.getItem("opened-cards"));
  jQuery(cards).each(function(ind, val) {
    if (val.id === activityid) {
      showDetails = true;
    }
  });

  function toggleShowDetails() {
    if (showDetails === "false") {
      showDetails = false;
    }
    showDetails = !showDetails;
    const id = activityid;

    openedCards = [];
    setTimeout(function() {
      jQuery(".card-container .content").each(function(ind, val) {
        if (
          jQuery(val)
            .parent()
            .html()
            .indexOf("content") > -1
        ) {
          openedCards.push({
            id: jQuery(val)
              .parent()
              .find(".card-title")
              .data("activityid"),
            status: showDetails
          });
        }
      });
      localStorage.setItem("opened-cards", JSON.stringify(openedCards));
    }, 100);
  }
</script>

<style>
  .card-container {
    margin-top: 10px;
    border: 1px solid #b2bec3;
    text-align: left;
    font-size: 13px;
  }
  .card-container-rejected {
    margin-top: 10px;
    border: 1px solid #fab1a0;
    text-align: left;
    font-size: 13px;
  }
  .card-container-approved {
    margin-top: 10px;
    border: 1px solid #10ac84;
    text-align: left;
    font-size: 13px;
  }
  .card-container-waiting {
    margin-top: 10px;
    border: 1px solid #fffa65;
    text-align: left;
    font-size: 13px;
  }

  .card-title {
    background-color: #dcdde1;
    width: 100%;
    border-bottom: 1px solid #b2bec3;
    padding: 10px;
    word-wrap: break-word;
    cursor: pointer;
  }
  .card-title-rejected {
    background-color: #ff7675;
    width: 100%;
    border-bottom: 1px solid #ff7675;
    padding: 10px;
    word-wrap: break-word;
    cursor: pointer;
  }
  .card-title-approved {
    background-color: #1dd1a1;
    width: 100%;
    border-bottom: 1px solid #10ac84;
    padding: 10px;
    word-wrap: break-word;
    cursor: pointer;
  }
  .card-title-waiting {
    background-color: #fffa65;
    width: 100%;
    border-bottom: 1px solid #fffa65;
    padding: 10px;
    word-wrap: break-word;
    cursor: pointer;
  }
  .content {
    padding: 10px;
    word-wrap: break-word;
  }
  .row-button-container button {
    border: 1px #b2bec3 solid;
    color: #3498db;
    border-radius: 5px;
    padding: 5px 10px;
    margin: 5px;
    background-color: white;
    text-decoration: none;
  }

  @media (max-width: 768px) {
    .card-container {
      margin: 20px 20px;
      display: inline-block;
      margin-top: 0px;
    }
    .card-container-approved {
      margin: 20px 20px;
      display: inline-block;
      margin-top: 0px;
    }
    .card-container-rejected {
      margin: 20px 20px;
      display: inline-block;
      margin-top: 0px;
    }
    .card-container-waiting {
      margin: 20px 20px;
      display: inline-block;
      margin-top: 0px;
    }
  }
  @media (max-width: 425px) {
    .card-container {
      margin: 10px 0px 10px 0px;
    }
    .card-container-approved {
      margin: 10px 0px 10px 0px;
    }
    .card-container-rejected {
      margin: 10px 0px 10px 0px;
    }
    .card-container-waiting {
      margin: 10px 0px 10px 0px;
    }
  }
</style>

{#if status === 2}
  <div class="card-container-approved">
    <div
      class="card-title-approved"
      on:click={toggleShowDetails}
      data-activityid={activityid}>
      {job}
    </div>
    {#if showDetails === true || collapseAll === true}
      <div class="content">
        <p>Deliverable: {deliverable}</p>
        <p>Task: {task}</p>
        <p>Total Hours: {totalhours}</p>
        <p>Notes: {title === null ? 'None' : title}</p>
        {#if user !== 1}
          <div class="row-button-container">
            <button on:click={toggleEdit}>Edit</button>
            <button on:click={toggle}>Delete</button>
          </div>
        {/if}
      </div>
    {/if}
  </div>
{:else if status === 3}
  <div class="card-container-rejected">
    <div class="card-title-rejected" on:click={toggleShowDetails}>{job}</div>
    {#if showDetails === true || collapseAll === true}
      <div class="content">
        <p>Deliverable: {deliverable}</p>
        <p>Task: {task}</p>
        <p>Total Hours: {totalhours}</p>
        <p>Notes: {title === null ? 'None' : title}</p>
        <div class="row-button-container">
          <button on:click={toggleEdit}>Edit</button>
          <button on:click={toggle}>Delete</button>
        </div>
      </div>
    {/if}
  </div>
{:else if status === 0}
  <div class="card-container">
    <div
      class="card-title"
      data-activityid={activityid}
      on:click={toggleShowDetails}>
      {job}
    </div>
    {#if showDetails === true || collapseAll === true}
      <div class="content">
        <p>Deliverable: {deliverable}</p>
        <p>Task: {task}</p>
        <p>Total Hours: {totalhours}</p>
        <p>Notes: {title === null ? 'None' : title}</p>
        {#if user !== 1 || status !== 1}
          <div class="row-button-container">
            <button on:click={toggleEdit}>Edit</button>
            <button on:click={toggle}>Delete</button>
          </div>
        {/if}
      </div>
    {/if}
  </div>
{:else if status === 1}
  <div class="card-container-waiting">
    <div class="card-title-waiting" on:click={toggleShowDetails}>{job}</div>
    {#if showDetails === true || collapseAll === true}
      <div class="content">
        <p>Deliverable: {deliverable}</p>
        <p>Task: {task}</p>
        <p>Total Hours: {totalhours}</p>
        <p>Notes: {title === null ? 'None' : title}</p>
        {#if user !== 1 || status !== 1}
          <div class="row-button-container">
            <button on:click={toggleEdit}>Edit</button>
            <button on:click={toggle}>Delete</button>
          </div>
        {/if}
      </div>
    {/if}
  </div>
{/if}

<DeleteModal {open} {toggle} {data} />
<EditModal {newdate} open={openEdit} toggle={toggleEdit} {data} />
